module.exports = __webpack_public_path__ + "img/businesLicense1.aaded2ac.png";